import { HttpResponse } from '@angular/common/http';

export function handleFileDownload(
    response: HttpResponse<Blob>,
    filenameToUseIfNotReturnedWithResponse: string,
): void {
    if (!response.body) {
        return;
    }

    const contentDisposition = response.headers?.get('Content-Disposition') ?? '';
    const filename = contentDisposition ? contentDisposition.split('filename=')[1].replace(/"/g, '') : `${filenameToUseIfNotReturnedWithResponse}`;

    downloadFile(response.body, filename);
}

function downloadFile(blob: Blob, filename: string): void {
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}
